import { Dispatch, FC, useState, useEffect } from "react";
import { StopEventPropagation } from "../../../helper/ui/methods";
import { ProjectContentFilterInterface } from "../../../middleware/interfaces/project/project-content-filter";
import { UserInterface } from "../../../middleware/interfaces/user/user-interface";

interface ProjectContentFilterDialogProps {
  reveal: boolean;
  user: UserInterface;
  setProjectContentfilterDialogReveal: Dispatch<React.SetStateAction<boolean>>;
  dispatch: Dispatch<any>;
}

const ProjectContentFilterDialog: FC<ProjectContentFilterDialogProps> = ({
  reveal,
  user,
  setProjectContentfilterDialogReveal,
  dispatch,
}) => {
  const [updatedProjectContentFilter, setUpdatedProjectContentFilter] =
    useState<ProjectContentFilterInterface>(() => {
      return user?.openProject?.projectContentFilter!;
    });

  useEffect(() => {
    if (user.openProject) {
      setUpdatedProjectContentFilter(user.openProject.projectContentFilter!);
    }
  }, [user.openProject]);

  const HandleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;

    if (name === "models" || name === "files") {
      setUpdatedProjectContentFilter((prevOptions) => ({
        ...prevOptions,
        filesAndModels: {
          ...prevOptions.filesAndModels,
          [name]: checked,
        },
      }));
    } else {
      setUpdatedProjectContentFilter((prevOptions) => ({
        ...prevOptions,
        [name]: checked,
      }));
    }
  };

  const HandleCancelClick = () => {
    setProjectContentfilterDialogReveal(false);
  };

  const HandleApplyClick = () => {
    const updatedUser = user;
    updatedUser!.openProject!.projectContentFilter =
      updatedProjectContentFilter;
    dispatch({
      type: "UPDATE_USER",
      payload: updatedUser,
      response: "",
    });
    setProjectContentfilterDialogReveal(false);
  };

  if (!reveal) {
    return null;
  }

  // one row per content type, each carrying the icon and colour the canvas
  // uses for it, so the dialog names the same things the canvas does
  const contentTypes = [
    { name: "folders", label: "Folders", imageSource: "assets/icons/folder.png" },
    { name: "reports", label: "Reports", imageSource: "assets/icons/report.png" },
    { name: "forges", label: "Forges", imageSource: "assets/icons/forge.png" },
    { name: "models", label: "Models", imageSource: "assets/icons/model.png" },
    { name: "files", label: "Files", imageSource: "assets/icons/file.png" },
  ];

  const IsChecked = (name: string) => {
    if (name === "models" || name === "files") {
      return updatedProjectContentFilter.filesAndModels[
        name as "models" | "files"
      ];
    }
    return updatedProjectContentFilter[name as "folders" | "reports" | "forges"];
  };

  return (
    <div className="dialogCover" onClick={StopEventPropagation}>
      <div className="dialog">
        <div className="dialogHeader">
          <div className="dialogHeading">
            <h2 className="dialogTitle">Filter contents</h2>
          </div>
          <span className="dialogClose" onClick={HandleCancelClick}>
            ×
          </span>
        </div>
        <div id="projectContentFilterWrapper">
          {contentTypes.map((contentType) => (
            <label
              key={contentType.name}
              className={
                IsChecked(contentType.name)
                  ? "dialogCheckRow dialogCheckRowSelected"
                  : "dialogCheckRow"
              }
            >
              <input
                type="checkbox"
                name={contentType.name}
                checked={IsChecked(contentType.name)}
                onChange={HandleCheckboxChange}
              />
              <img
                src={contentType.imageSource}
                draggable="false"
                alt={contentType.label}
              />
              <span className="dialogCheckRowLabel">{contentType.label}</span>
            </label>
          ))}
        </div>
        <div className="dialogButtonWrapper">
          <input
            type="button"
            name="cancel"
            value="Cancel"
            onClick={HandleCancelClick}
          />
          <input
            className="dialogPrimaryButton"
            type="button"
            name="apply"
            value="Apply"
            onClick={HandleApplyClick}
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectContentFilterDialog;
